import React from 'react';
import './index.scss';

//api
import {api} from '../../../../functions/api'

//material-ui
import CircularProgress from '@material-ui/core/CircularProgress';

//custom components
import Search from '../../../../components/basic/search';
import CustomButton from '../../../../components/basic/CustomButton';
import CustomTable from '../../../../components/complex/customTable';
import NewEditBranch from './add';
import DeleteDialog from '../../../../components/global/deleteDialog';
import CustomSnackbar from '../../../../components/global/snackbar';

//other libraries
import Icon from '@mdi/react';
import {mdiPlus} from '@mdi/js';
import { inject, observer } from 'mobx-react';
import queryString from 'query-string';
import {toJS} from 'mobx';



const TIMEOUT = 3000;

@inject('translate')
@inject('internal')
@observer
export default class ClientBranchces extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            loading: true,
            openSnackbar: false,
            message: "",
            newBranch: false,
        }
    }

    dropDownMenuItems = [
        // {
        //     title: this.props.translate.i18n.GLOBAL.BUTTONS.EDIT,
        //     action: "edit"
        // },
        // {
        //     title: this.props.translate.i18n.GLOBAL.BUTTONS.DELETE,
        //     action: "delete"
        // }
    ]

    componentDidMount() {
        if(toJS(this.props.internal.user) && toJS(this.props.internal.user.data) && toJS(this.props.internal.user.data.permissions)) {
            this.setPermissions()
        }

        this.loadClientBranches();
        this.props.internal.setRoute( this.props.routerData.history, this.props.routerData.location.pathname)
    }

    setPermissions () {
        this.dropDownMenuItems = []
        let permissions = toJS(this.props.internal.user.data.permissions);
        if(permissions.clients_branches && permissions.clients_branches.update) {
            this.dropDownMenuItems.push(
                {
                    title: this.props.translate.i18n.GLOBAL.BUTTONS.EDIT,
                    action: "edit"
                },
                // {
                //     title: this.props.translate.i18n.GLOBAL.BUTTONS.DELETE,
                //     action: "delete"
                // }
            )
        }
    }

    timeout = null;
    componentWillUnmount() {
        clearTimeout(this.timeout)
    }

    turnOffSnackBar = () => {
        clearTimeout(this.timeout)
        this.timeout =  setTimeout(() => {
            this.setState({message: "", openSnackbar: false})
        }, TIMEOUT)
    }

    loadClientBranches = async(size = 10, page = 0, searchterm = " ", by = "name", dir = "asc") => {
        //this.setState({loading: true})
        const URLqueryString = this.props.routerData.history.location.search
        let queries = queryString.parse(URLqueryString);

        if(queries) {
            
            if(queries.page_number) {
                page = queries.page_number
            }

            if(queries.page_size) {
                size = queries.page_size
            }

            if(queries.by) {
                by = queries.by
            }

            if(queries.dir) {
                dir = queries.dir
            }

            if(queries.searchterm) {
                searchterm = queries.searchterm
            }
        }

        let idClient = toJS(this.props.routerData.match.params.idClient)

        let load_data = await api({
            method: 'get',
            url: 'clients/'+idClient+'/branches',
            authorization: this.props.internal.user.access_token,
            params: {
                searchterm: searchterm,
                page: {
                    number: page,
                    size: size
                },
                order: [
                    {
                        by: by,
                        dir: dir
                    },
                ]
            }
        })

        if(load_data.success === true) {
            this.props.internal.setDataForTable(load_data.data)
        }

        this.setState({loading: false})
    }

    handleDeleteBranch = () => {
        this.props.internal.setActionDelete();
        this.deleteBranch(toJS(this.props.internal.actionDeleteObj.id))
    }

    deleteBranch = async (idBranch) => {
        let idClient = toJS(this.props.routerData.match.params.idClient)
        let delete_data = await api({
            method:'delete',
            url:'clients/'+ idClient +'/branches/' + idBranch,
            authorization: this.props.internal.user.access_token,
        })

        if(delete_data.success === true) {
            this.setState({message: delete_data.data.message, openSnackbar: true})
            this.loadClientBranches();
        }
        else {
            this.setState({message: delete_data.data.message, openSnackbar: true})
            this.loadClientBranches();
        }
        this.turnOffSnackBar();
    }

    handleChangeRowsPerPage = (size) => {
        this.setState({
            loading: true
        });
        // let searchTerm = " ";
        // if (toJS(this.props.internal.dataForTable.meta.searchterm) !== false) {
        //     searchTerm = toJS(this.props.internal.dataForTable.meta.searchterm)
        // }
        this.addQueryToUrl("page_size", size)
    }

    handleChangePage = (page) => {
        this.setState({
            loading: true
        });
        // let searchTerm = " ";
        // if (toJS(this.props.internal.dataForTable.meta.searchterm) !== false) {
        //     searchTerm = toJS(this.props.internal.dataForTable.meta.searchterm)
        // }

        this.addQueryToUrl("page_number", page + 1)
    }

    handleSearch = (searchTerm) => {

        if (searchTerm.length > 2) {
            this.addQueryToUrl("searchterm", searchTerm)
        }
        else {
            this.addQueryToUrl("searchterm", "")
        }
    }

    handleSort = (dir, orderBy) => {
        this.setState({
            loading: true
        })
        this.addQueryToUrl("dir", dir)
        this.addQueryToUrl("by", orderBy)
    }

    addQueryToUrl = (param, value) => {
        const URLqueryString = this.props.routerData.history.location.search
        let queries = queryString.parse(URLqueryString)
        queries[param] = value

        let new_path = this.props.routerData.location.pathname

        new_path += "?"
        for(let key in queries) {
            if(key) {
                new_path += key + "=" + queries[key] + "&"
            }
        }
        new_path = new_path.slice(0,-1)

        this.props.internal.pushRoute(new_path)
        this.loadClientBranches()
    }

    handleCloseEditClientDlialog = () => {
        if(this.state.newBranch === true) {
            this.setState({newBranch: false})
        }
        else {
            let actionEditData = {
                edit: false,
                id: null
            }
            this.props.internal.setActionEdit(actionEditData)
        }
    }

    showSnackbar = (message, open, dialogStatus) => {
        this.setState({message: message, openSnackbar: open})
        if(this.state.newBranch === true && dialogStatus) {
            this.setState({newBranch: false})
        }
        this.turnOffSnackBar();
        this.loadClientBranches();
    }

    handleClickOpenAddClientDlialog = () => {
        this.setState({newBranch: true})
    }


    tableHeader = [
        {"title":"name", "numeric":false, "min_width": "80px"},
        {"title":"branch_id", "numeric":false},
        {"title":"address", "numeric":false}
    ];
    tableBody = ["name", "branch_id", "address"]

    render() {
        let permissions = toJS(this.props.internal.user.data.permissions)
        return (
            this.state.loading
                ?
                <CircularProgress className={'circular-progress'} />
                :
                <div className={'client-branchces'}>
                    <div className={'flex space-between'}>
                        <Search placeholder={this.props.translate.i18n.MODULES.CLIENTS.BRANCHE_SEARCH} classes={'client-search'} onChange={this.handleSearch}/>
                        {permissions.clients_branches && permissions.clients_branches.store ?
                            <CustomButton
                            mystyle={'btn-orange-bg border-radius-18'}
                                title={this.props.translate.i18n.MODULES.CLIENTS.CREATE_NEW_BRANCH}
                                onClick={this.handleClickOpenAddClientDlialog}
                            >
                                <Icon path={mdiPlus} size={1}  />
                            </CustomButton>
                            :
                            null
                        }
                    </div>
                    {/* edit */}
                    <NewEditBranch
                        open={this.props.internal.actionEdit.edit}
                        onClose={this.handleCloseEditClientDlialog}
                        title={this.props.translate.i18n.MODULES.CLIENTS.EDIT_BRANCH_TITLE}
                        routerData={this.props.routerData}
                        showSnackbar={this.showSnackbar}
                        idBranch={this.props.internal.actionEdit.id}
                    />
                    {/* new */}
                    <NewEditBranch
                        open={this.state.newBranch}
                        onClose={this.handleCloseEditClientDlialog}
                        title={this.props.translate.i18n.MODULES.CLIENTS.NEW_BRANCH_TITLE}
                        routerData={this.props.routerData}
                        showSnackbar={this.showSnackbar}
                    />
                    <DeleteDialog
                        open={this.props.internal.actionDelete}
                        title={this.props.translate.i18n.MODULES.CLIENTS.DELETE_BRANCH_TITLE}
                        content={this.props.translate.i18n.GLOBAL.ALERTS.DELETE_ITEM}
                        btn_cancel={this.props.translate.i18n.GLOBAL.BUTTONS.CANCEL}
                        btn_delete={this.props.translate.i18n.GLOBAL.BUTTONS.DELETE}
                        delete={this.handleDeleteBranch}
                    />
                    <CustomSnackbar message={this.state.message} open={this.state.openSnackbar} />
                    <CustomTable
                        dropDownMenuItems={this.dropDownMenuItems}
                        module={'/clients'}
                        handleChangeRowsPerPage={this.handleChangeRowsPerPage}
                        handleChangePage={this.handleChangePage}
                        handleSort={this.handleSort}
                        header={this.tableHeader}
                        body={this.tableBody}
                    />

                </div>
        );
    }
}



// WEBPACK FOOTER //
// ./src/screens/clients/detail/branches/index.js